"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const roomViewStore_1 = require("@/room/room_view/roomViewStore");
const html_react_parser_1 = __importDefault(require("html-react-parser"));
const moment_1 = __importDefault(require("moment"));
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const string_utils_1 = require("@/common/string_utils");
const material_ui_confirm_1 = require("material-ui-confirm");
const Button_1 = __importDefault(require("@mui/material/Button"));
const Collapse_1 = __importDefault(require("@mui/material/Collapse"));
const Fade_1 = __importDefault(require("@mui/material/Fade"));
const styled_1 = __importDefault(require("@emotion/styled"));
const __1 = require("..");
const _1 = require(".");
exports.default = (0, styled_1.default)((_a) => {
    var { question } = _a, props = __rest(_a, ["question"]);
    const isAdmin = (0, react_redux_1.useSelector)((state) => state.whoAmI.is_admin);
    const userId = (0, react_redux_1.useSelector)((state) => state.whoAmI.id);
    const leaderId = (0, react_redux_1.useSelector)((state) => state.roomData.leader);
    const { id: questionId, is_secret: isSecret, nickname, regTime, reply: replies, text, writer: writerId, is_deleted, } = question;
    const isLeader = userId === leaderId;
    const isLeaderQuestion = leaderId === writerId;
    const isMyQuestion = writerId === userId;
    const permissionToRead = (() => {
        if (isSecret) {
            if (isLeader || isMyQuestion || isAdmin)
                return true;
            else
                return false;
        }
        else
            return true;
    })();
    const myQuestionId = `question_${questionId}`;
    const { t } = (0, react_i18next_1.useTranslation)();
    const contents = permissionToRead ? (0, html_react_parser_1.default)((0, string_utils_1.newLineCharsToBr)(text)) : t('비밀글 입니다.');
    const regDate = (0, moment_1.default)(regTime).format('YYYY.MM.DD HH:mm');
    const [editMode, setEditMode] = (0, react_1.useState)(false);
    const [replyMode, setReplyMode] = (0, react_1.useState)(false);
    const dispatch = (0, react_redux_1.useDispatch)();
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const [deleting, setDeleting] = (0, react_1.useState)(false);
    const removeAction = () => {
        const deleteFn = () => dispatch((0, roomViewStore_1.removeComment)({ commentId: myQuestionId, setDeleting }));
        (0, _1.deleteQnAConfirm)({ confirm, deleteFn });
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({}, props, { children: [(0, jsx_runtime_1.jsx)(Collapse_1.default, Object.assign({ in: editMode, timeout: 0 }, { children: (0, jsx_runtime_1.jsx)(Fade_1.default, Object.assign({ in: editMode, timeout: 300 }, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(__1.CommentForm, { commentId: myQuestionId, defaultValue: text, focusDep: editMode, secret: isSecret, onCancel: () => setEditMode(false) }) }) })) })), (0, jsx_runtime_1.jsx)(Collapse_1.default, Object.assign({ in: !editMode, timeout: 0 }, { children: (0, jsx_runtime_1.jsx)(Fade_1.default, Object.assign({ in: !editMode, timeout: 300 }, { children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ translate: "no", className: "question_nickname" }, { children: `${nickname}${isLeaderQuestion ? ' ' + t('작가님') : ''}` })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ translate: "no", className: "question_contents" }, { children: [isSecret && (0, jsx_runtime_1.jsx)(svgs_1.LockerIconYellowSvg, {}), contents] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "comment_btns" }, { children: [(0, jsx_runtime_1.jsxs)("span", { children: [regDate, permissionToRead && !is_deleted && (0, jsx_runtime_1.jsx)(_1.ReportButton, { commentNumber: questionId })] }), !is_deleted && ((0, jsx_runtime_1.jsxs)("span", { children: [isMyQuestion && ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ variant: "black_outlined_small", onClick: () => setEditMode(true) }, { children: t('수정') }))), (isAdmin || isMyQuestion) && ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ disabled: deleting, variant: "black_outlined_small", onClick: removeAction }, { children: t('삭제') }))), isLeader && ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ variant: "black_outlined_small", onClick: () => setReplyMode(!replyMode) }, { children: t('답글') })))] }))] }))] }) })) })), (0, jsx_runtime_1.jsx)(Collapse_1.default, Object.assign({ in: replyMode, timeout: 150 }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "reply_new" }, { children: (0, jsx_runtime_1.jsx)(__1.CommentForm, { commentId: `new-reply_${questionId}`, focusDep: replyMode, onCancel: () => setReplyMode(false) }) })) })), Boolean(replies.length) && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "reply_list" }, { children: replies
                    .slice(0)
                    .reverse()
                    .map((reply, index) => ((0, jsx_runtime_1.jsx)(_1.Answer, { reply: reply, questionId: questionId, isMyQuestion: isMyQuestion }, `answer_${index}_${reply.id}`))) })))] })));
}) `
  padding: 16px 20px 12px;
  border-bottom: 1px solid #f8f8f8;
  .question_nickname {
    padding-bottom: 10px;
    font-size: 13px;
    font-weight: 700;
  }
  .question_contents {
    svg {
      margin-right: 6px;
    }
    padding-bottom: 8px;
    line-height: 22px;
    font-size: 15px;
    word-break: break-all;
  }
  .comment_btns {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    height: 24px;
    > span:first-of-type {
      display: flex;
      align-items: center;
      column-gap: 4px;
      margin-top: 2px;
      color: rgba(0, 0, 0, 0.2);
      font-size: 12px;
      letter-spacing: -0.2px;
    }
    > span:last-of-type {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      column-gap: 8px;
    }
  }
  .reply_new {
    margin-top: 12px;
    padding: 16px 12px 5px;
    border-radius: 0 12px 12px 12px;
    background-color: #f8f8f8;
  }
  .reply_list {
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    padding-top: 12px;
  }
`;
